import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "autocomplete-popup__input-container q-input-group q-mb-1 q-input-group" }
const _hoisted_2 = ["placeholder", "aria-label"]

import {toRefs, ref, inject} from 'vue';
import {useSearchQueryStore} from "@/store/SearchQueryStore";
import {usePopupStore} from "@/store/AutocompletePopup/PopupStore";
import {useUrlStore} from "@/store/SerpPage/UrlStore";
import {SmartSearchConfigInterface, SmartSearchTranslationsInterface} from "@/core/types";
import {storeToRefs} from "pinia";
import {useMobileViewStore} from "@/store/MobileViewStore";

import DOMPurify from "dompurify";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchOnlyInput',
  props: {
  autocomplete: Boolean
},
  setup(__props) {

const props = __props;


const urlStore = useUrlStore()

const queryStore = useSearchQueryStore();
const {searchQuery} = toRefs(queryStore)
const popupStore = usePopupStore()
const mobileViewStore = useMobileViewStore();
const {isMobileView} = storeToRefs(mobileViewStore)


// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchConfig = ref(inject<SmartSearchConfigInterface>('SmartSearchConfig')!)
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = ref(inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!)

const {redirectionUrl} = SmartSearchConfig.value.appConfiguration
const showButtonOnInput = props.autocomplete ? SmartSearchConfig.value.autocomplete.showButtonOnInput : SmartSearchConfig.value.serp.showButtonOnInput

const handleKeyUpConditional = () => {
  if (props.autocomplete) {
    popupStore.handleKeyUp();
  }
};


const handleRedirection = () => {
  const sanitised = DOMPurify.sanitize(queryStore.searchQuery)
  urlStore.goToSerpPage(`${redirectionUrl}?q=${sanitised}`, redirectionUrl);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchQuery) ? (searchQuery).value = $event : null)),
      onKeyup: [
        handleKeyUpConditional,
        _withKeys(handleRedirection, ["enter"])
      ],
      type: "text",
      class: _normalizeClass(["autocomplete-search__input q-form-control q-position-relative q-rounded-3 q-shadow-sm", { 'q-input-with-button': _unref(showButtonOnInput) && !_unref(isMobileView) ,
         'autocomplete-search__input-max-width': __props.autocomplete}]),
      id: "autocomplete-search__input",
      placeholder: SmartSearchTranslations.value.autocomplete.whatSearch,
      "aria-label": SmartSearchTranslations.value.autocomplete.typeTerm,
      "aria-describedby": "search-input",
      autocomplete: "off"
    }, null, 42, _hoisted_2), [
      [_vModelText, _unref(searchQuery)]
    ]),
    (_unref(showButtonOnInput) && ((!_unref(isMobileView) && __props.autocomplete ) || !__props.autocomplete))
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "autocomplete-search__input-button q-btn q-btn-danger q-shadow-sm",
          type: "button",
          id: "autocomplete-search__input-button",
          onClick: handleRedirection
        }, _toDisplayString(SmartSearchTranslations.value.autocomplete.inputButton), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})